<template>
  <div class="overview-process">
    <div class="accordion-header">
      <slot name="txtAccordionHeader">{{ processIdentifier }}</slot>
      <div class="accordion-button-wrapper">
        <b-btn class="accordion-cta" @click="cta()" v-if="showCta">
          <slot name="btnAccordionCta">CTA</slot>
        </b-btn>
        <b-btn class="accordion-toggle" @click="visible = !visible">
          <slot name="btnToggleOpen" v-if="visible">schließen</slot>
          <slot name="btnToggleClosed" v-if="!visible">Öffnen</slot>
        </b-btn>
      </div>
    </div>
    <b-collapse v-model="visible">
      <dyn-slot v-if="visible">
        <slot name="core"></slot>
      </dyn-slot>
    </b-collapse>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'ProcessAccordion',
  data () {
    return {
      visible_: null
    }
  },
  mixins: [
    slotProxy()
  ],
  mounted () {
    const comp = this
    document.addEventListener(`accordion-${this.processIdentifier}`, function (event) {
      if (event.detail.type === 'open') {
        comp.visible = true
        if (event.detail?.scrollIntoView) {
          comp.$el.scrollIntoView()
        }
      }
      if (event.detail.type === 'close') {
        comp.visible = false
      }
    })
  },
  computed: {
    errorName: function () {
      return this.processConfig?.errorName || this.processIdentifier
    },
    appendix: function () {
      return this.processIdentifier.charAt(0).toUpperCase() + this.processIdentifier.slice(1)
    },
    visible: {
      get () {
        if (this.visible_ !== null) {
          return this.visible_
        }
        return this.processConfig?.visible || this.forcedOpen || false
      },
      set (visible) {
        this.visible_ = visible
      }
    },
    hasCta: function () {
      return (this.processConfig?.cta || null) !== null
    },
    showCta: function () {
      return this.hasCta && this.visible && !this.ctaHidden
    },
    ctaHidden: function () {
      const getter = this.processConfig?.ctaHidden || null
      if (getter === null) {
        return false
      }
      return this.$store?.getters[getter] || false
    },
    forcedOpen () {
      const getter = this.processConfig?.openOn || null
      if (getter === null) {
        return false
      }
      return this.$store?.getters[getter] || false
    }
  },
  methods: {
    closeWhenError (allErr) {
      if (typeof this.errorName === 'string') {
        this.visible = allErr.includes(this.errorName)
      } else if (Array.isArray(this.errorName)) {
        this.visible = this.errorName.filter(name => {
          return allErr.includes(name)
        }).length > 0
      }
    },
    cta () {
      this.$store.commit(this.processConfig?.cta)
    }
  },
  props: {
    processIdentifier: {
      type: String,
      default: ''
    },
    /**
     * supported attributes:
     * - visible (bool) - open by default
     * - cta (string) - name of a mutation for the cta button
     * - ctaHidden (string) - name of a store getter to check if cta is hidden (should return bool)
     * - openOn (string) - name of a store getter to check if this should be opened on load (should return bool)
     */
    processConfig: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
